/* PackageSummaryMixin.js */

"use strict";
const _ = require("lodash");

const PackageSummaryMixin = (Parent) =>
    class PackageSummary extends Parent {
        constructor() {
            super();
        }
        /*** repo id ***/
        get repoId() {
            return this.getRepoId();
        }
        getRepoId() {
            return _.get(this._pkgSummary, "remote.repository.id");
        }
        /*** repo name ***/
        get repoName() {
            return this.getRepoName();
        }
        getRepoName() {
            return _.get(this._pkgSummary, "remote.repository.name");
        }
        /*** repo type ***/
        get repoType() {
            return this.getRepoType();
        }
        getRepoType() {
            return _.get(this._pkgSummary, "remote.repository.type");
        }
        /*** repo uri ***/
        get repoUri() {
            return this.getRepoUri();
        }
        getRepoUri() {
            return _.get(this._pkgSummary, "remote.repository.uri");
        }
        /*** repo description ***/
        get repoDescription() {
            return this.getRepoDescription();
        }
        getRepoDescription() {
            return _.get(this._pkgSummary, "remote.repository.description");
        }
        /*** repo username ***/
        get repoUserName() {
            return this.getRepoUserName();
        }
        getRepoUserName() {
            return _.get(this._pkgSummary, "remote.repository.userName");
        }
        /*** REPO ***/
        get repo() {
            return this.getRepo();
        }
        getRepo() {
            return this._repo;
        }

        /*** remote id ***/
        get id() {
            return this.getId();
        }
        getId() {
            let id = this.getLocalPkgId();
            if (!id) {
                id = this.getRemotePkgId();
            }
            return id;
        }

        /*** local ***/
        get localPkgDetails() {
            return this.getLocalPkgDetails();
        }
        getLocalPkgDetails() {
            return _.get(this._pkgSummary, "local");
        }
        /*** local id ***/
        get localPkgId() {
            return this.getLocalPkgId();
        }
        getLocalPkgId() {
            return _.get(this._pkgSummary, "local.pkgId");
        }

        /*** remote ***/
        get remotePkgDetails() {
            return this.getRemotePkgDetails();
        }
        getRemotePkgDetails() {
            return _.get(this._pkgSummary, "remote");
        }

        /*** remote id ***/
        get remotePkgId() {
            return this.getRemotePkgId();
        }
        getRemotePkgId() {
            return _.get(this._pkgSummary, "remote.pkgId");
        }

        /*** name ***/
        get name() {
            return this.getName();
        }
        getName() {
            return _.get(this._pkgSummary, "local.name", _.get(this._pkgSummary, "remote.name"));
        }
        /*** description ***/
        get description() {
            return this.getDescription();
        }
        getDescription() {
            return _.get(
                this._pkgSummary,
                "local.description",
                _.get(this._pkgSummary, "remote.description")
            );
        }
        /*** Diff Details ***/
        get diffDetails() {
            return this.getDiffDetails();
        }
        getDiffDetails() {
            return _.get(this._pkgSummary, "diff");
        }
        /*** Package Summary ***/
        get packageSummary() {
            return this.getPackageSummary();
        }
        getPackageSummary() {
            return this._pkgSummary;
        }
        set packageSummary(pkg) {
            return this.setPackageSummary(pkg);
        }
        setPackageSummary(pkg, silent) {
            let old = this.packageSummary;
            this._pkgSummary = pkg;
            if (!silent) {
                this.emit("PackageSummaryReplaced", this.packageSummary, old);
            }
            return this;
        }
    };
module.exports = PackageSummaryMixin;
